import React from 'react';
import ButtonBase from '@mui/material/ButtonBase';
import Tooltip from '@mui/material/Tooltip';
import SearchIcon from '@mui/icons-material/Search';
import useVoyagerStore from '../../../stores/useVoyagerStore';
import type { ExploreTarget } from '../AnswerCard';
import { ROW_ACT } from './ResultPanel';

const WORD = {
  ...ROW_ACT,
  '&[aria-disabled="true"]': { color: 'var(--ink-4, var(--ink-3))', cursor: 'default', '&:hover': { bgcolor: 'transparent' } },
} as const;

/**
 * The reply row's first word: this answer's query, opened in the Query Builder, with the way back to this turn. A query
 * that can't be opened as it ran, or that fails on the way (its perspective has gone), goes muted and says why in its
 * tooltip; it never opens an empty builder.
 */
export default function ExploreAction({ target, turnId, what }: { target: ExploreTarget; turnId: string; what: string }) {
  const navigate = useVoyagerStore((s) => s.navigateToWorkspaceWithSpec);
  const [failed, setFailed] = React.useState<string | null>(null);
  const why = target.reason || failed;
  const open = async () => {
    if (!why) setFailed(await navigate(target.spec, { threadId: useVoyagerStore.getState().currentThreadId, turnId }));
  };
  return (
    <Tooltip title={why || `Open “${what}” in the Query Builder`} describeChild arrow enterTouchDelay={0}>
      <ButtonBase onClick={open} aria-disabled={!!why} sx={WORD} data-testid="explore-answer">
        <SearchIcon sx={{ fontSize: 15 }} />Explore
      </ButtonBase>
    </Tooltip>
  );
}
